import React, { useState, useEffect } from 'react'
import queryString from 'query-string'
import { analytics } from 'firebase'
import { withTranslation } from 'react-i18next'

import classes from './Footer.module.css'
import github from '../../images/github.svg'
import bitcoin from '../../images/bitcoin.svg'
import telegram from '../../images/telegram.svg'
import youtube from '../../images/youtube.svg'
import facebook from '../../images/facebook.svg'
import twitter from '../../images/twitter.svg'
import instagram from '../../images/instagram.svg'
import vk from '../../images/vk.svg'
import bitsmedia from '../../images/listing/88x31(2).png'
import kurs from '../../images/listing/log.png'
import { strings } from '../../i18n'

const Footer = () => {

    const [externalID, setExternalId] = useState(false)

    useEffect(() => {
        const url = window.location.href
        const urlParamsString = url.slice((url.indexOf('?')) + 1)
        const urlParamsObj = queryString.parse(urlParamsString)

        const externalId = urlParamsObj.externalId || null
        setExternalId(externalId)
    }, [])

    return (
        <footer className={classes.footer} style={{ display: externalID ? 'none' : 'flex' }}>
            <div className={classes.footer__wrapper}>
                <div className={classes.links}>
                    <a href="https://kurs.com.ua/forums/topic/4917-trusteedeals/" title="Мониторинг обменников электронных валют" target="_blank" rel={'noopener noreferrer'}>
                        <img src="https://kurs.com.ua/static/images/banner/88x31.png" width="88" height="31" alt="kurs.com.ua" />
                    </a>
                    <a href="https://eobmen-obmen.ru/exchange-trustee-detali" title="Мониторинг обменников eobmen-obmen.ru" target="_blank" rel={'noopener noreferrer'}>
                        <img src="https://eobmen-obmen.ru/images/inform5.gif" alt="eobmen-obmen.ru - просто сравни курcы" />
                    </a>
                    <a href="https://kursoff.com/exchange/Trustee%20Wallet" target="_blank" rel={'noopener noreferrer'}>
                        <img src="https://kursoff.com/images/banners/banner1.gif" alt="https://kursoff.com" />
                    </a>
                    <a href={'https://bits.media/exchanger/trustee-deals'} target="_blank" rel={'noopener noreferrer'}>
                        <img src={bitsmedia} alt={'bitsmedia'} />
                    </a>
                    <a href='https://exchangesumo.com/exchanger/942/Trustee' title='Сервис поиска выгодного курса обмена' target="_blank" rel={'noopener noreferrer'}>
                        <img src='https://b.exchangesumo.com/i/1.svg' width='88' height='31' border='0' alt='https://b.exchangesumo.com' />
                    </a>
                    <a href="https://kurs.expert" title="Обмен Биткоин, Киви, Яндекс, AdvCash" target="_blank" rel={'noopener noreferrer'}>
                        <img src={kurs} width="31" height="31" border="0" alt={'https://kurs.expert'} />
                    </a>
                </div>
                <div className={classes.line}></div>
                <div className={classes.footer__items}>
                    <div className={classes.list} id={classes.company}>
                        <a href={'https://blocksoftlab.com/'} target={'_blank'} rel={'noopener noreferrer'} onClick={() => {
                            analytics().logEvent('click_blocksoftlab')
                        }}>
                            <h3 className={classes.list__item__header}>Blocksoftlab Inc</h3>
                        </a>
                        <div className={classes.right__reserved}>© {strings('footer.rightsReserved')}</div>
                    </div>
                    <div className={classes.list} id={classes.info}>
                        <h3 className={classes.list__item__header}>
                            {strings('footer.info')}
                        </h3>
                        <div className={classes.list__item}>
                            <a href={'https://t.me/trustee_support_bot'} target="_blank"
                                rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_support')
                                }}>
                                {strings('footer.support')}
                            </a>
                        </div>
                        <div className={classes.list__item}>
                            <a href={'https://blog.trustee.deals/ru/blog/'} target="_blank" rel={'noopener noreferrer'}
                                onClick={() => {
                                    analytics().logEvent('click_blog')
                                }}>
                                {strings('footer.blog')}
                            </a>
                        </div>
                        <div className={classes.list__item}>
                            <a href={'https://trustee.deals/faq'} target="_blank" rel={'noopener noreferrer'}
                                onClick={() => {
                                    analytics().logEvent('click_faq')
                                }}>
                                {strings('footer.faq')}
                            </a>
                        </div>
                        <div className={classes.list__item}>
                            <a href={'mailto:contact@trustee.deals'} target="_blank" rel={'noopener noreferrer'}
                                onClick={() => {
                                    analytics().logEvent('click_contact_us')
                                }}>
                                {strings('footer.contactUs')}
                            </a>
                        </div>
                    </div>
                    <div className={classes.list} id={classes.buy}>
                        <h3 className={classes.list__item__header}>
                            {strings('footer.buyCrypto')}
                        </h3>
                        <div className={classes.list__item}>
                            <a href={'https://trustee.deals/buy-bitcoin'} target="_blank"
                                rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_buy_bitcoin')
                                }}>
                                {strings('footer.buyBitcoin')}
                            </a>
                        </div>
                        <div className={classes.list__item}>
                            <a href={'https://trustee.deals/buy-ethereum'} target="_blank"
                                rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_but_ethereum')
                                }}>
                                {strings('footer.buyEthereum')}
                            </a>
                        </div>
                    </div>
                    <div className={classes.list} id={classes.document}>
                        <h3 className={classes.list__item__header}>{strings('footer.documents')}</h3>
                        <div className={classes.list__item}>
                            <a href={'https://docs.google.com/document/d/1HqK6qRWyZkGdOLTOYTynTFJ9tesvqIuQjhyF6nn16bM/edit'}
                                target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_privacy_policy')
                                }}>
                                {strings('footer.privacyPolicy')}
                            </a>
                        </div>
                        <div className={classes.list__item}>
                            <a href={'https://docs.google.com/document/d/1xvDZuqeAliCoX-_FUvjq_MmOIu64oWNz0623dcxEL_8/edit'}
                                target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_term_of_use')
                                }}>
                                {strings('footer.termOfUse')}
                            </a>
                        </div>
                        <div className={classes.list__item}>
                            <a href={'https://docs.google.com/document/d/1DjWF4obwXVqNUtnR5op5ZQPL-lqThfcwu5M9u8z742w/edit'}
                                target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_legal_status')
                                }}>
                                {strings('footer.legalStatus')}
                            </a>
                        </div>
                        <div className={classes.list__item}>
                            <a href={'https://drive.google.com/drive/folders/1Tn7kjtcRUvToVFZ_6OnFpGWbIfjWV6K9?usp=sharing'}
                                target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_press_kit')
                                }}>
                                {strings('footer.pressKit')}
                            </a>
                        </div>
                    </div>
                    <div className={classes.logo} id={classes.logo}>
                        <div className={classes.logo__item}>
                            <a href={'https://github.com/trustee-wallet/trusteeWallet'} target="_blank"
                                rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_github')
                                }}>
                                <div className={classes.circle}>
                                    <img src={github} alt={'github'} width={30} />
                                </div>
                            </a>
                            <a href={'https://bitcointalk.org/index.php?topic=5153571.msg51442318#msg51442318'}
                                target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_bitcoin')
                                }}>
                                <div className={classes.circle}>
                                    <img src={bitcoin} alt={'bitcoin'} width={30} />
                                </div>
                            </a>
                            <a href={'http://t.me/trustee_wallet'} target="_blank" rel={'noopener noreferrer'}
                                onClick={() => {
                                    analytics().logEvent('click_telegram')
                                }}>
                                <div className={classes.circle}>
                                    <img src={telegram} alt={'telegram'} width={30} />
                                </div>
                            </a>
                            <a href={'https://www.youtube.com/c/TrusteeWallet/featured'} target="_blank"
                                rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_youtube')
                                }}>
                                <div className={classes.circle}>
                                    <img src={youtube} alt={'youtube'} width={30} />
                                </div>
                            </a>
                            {/*</div>*/}
                            {/*<div className={classes.logo__item}>*/}
                            <a href={'https://www.facebook.com/Trustee.Wallet/'} target="_blank"
                                rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_facebook')
                                }}>
                                <div className={classes.circle}>
                                    <img src={facebook} alt={'facebook'} width={30} />
                                </div>
                            </a>
                            <a href={'https://www.instagram.com/trustee_wallet/'} target="_blank"
                                rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_instagram')
                                }}>
                                <div className={classes.circle}>
                                    <img src={instagram} alt={'instagram'} width={30} />
                                </div>
                            </a>
                            <a href={'https://twitter.com/Trustee_Wallet'} target="_blank"
                                rel={'noopener noreferrer'} onClick={() => {
                                    analytics().logEvent('click_twitter')
                                }}>
                                <div className={classes.circle}>
                                    <img src={twitter} alt={'twitter'} width={30} />
                                </div>
                            </a>
                            <a href={'https://vk.com/trustee_wallet'} target="_blank" rel={'noopener noreferrer'}
                                onClick={() => {
                                    analytics().logEvent('click_vk')
                                }}>
                                <div className={classes.circle}>
                                    <img src={vk} alt={'vk'} width={30} />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.footer__mobile}>
                <div className={classes.links}>
                    <a href="https://kurs.com.ua/forums/topic/4917-trusteedeals/" title="Мониторинг обменников электронных валют" target="_blank" rel={'noopener noreferrer'}>
                        <img src="https://kurs.com.ua/static/images/banner/88x31.png" width="88" height="31" alt="kurs.com.ua" />
                    </a>
                    <a href="https://eobmen-obmen.ru/exchange-trustee-detali" title="Мониторинг обменников eobmen-obmen.ru" target="_blank" rel={'noopener noreferrer'}>
                        <img src="https://eobmen-obmen.ru/images/inform5.gif" alt="eobmen-obmen.ru - просто сравни курcы" />
                    </a>
                    <a href="https://kursoff.com/exchange/Trustee%20Wallet" target="_blank" rel={'noopener noreferrer'}>
                        <img src="https://kursoff.com/images/banners/banner1.gif" alt="https://kursoff.com" />
                    </a>
                    <a href={'https://bits.media/exchanger/trustee-deals'} target="_blank" rel={'noopener noreferrer'}>
                        <img src={bitsmedia} alt={'bitsmedia'} />
                    </a>
                    <a href='https://exchangesumo.com/exchanger/942/Trustee' title='Сервис поиска выгодного курса обмена' target="_blank" rel={'noopener noreferrer'}>
                        <img src='https://b.exchangesumo.com/i/1.svg' width='88' height='31' border='0' alt='https://b.exchangesumo.com' />
                    </a>
                    <a href="https://kurs.expert" title="Обмен Биткоин, Киви, Яндекс, AdvCash" target="_blank" rel={'noopener noreferrer'}>
                        <img src={kurs} width="31" height="31" border="0" alt={'https://kurs.expert'} />
                    </a>
                </div>
                <div className={classes.line}></div>
                <div className={classes.list} id={classes.document}>
                    <h3 className={classes.list__item__header}>{strings('footer.documents')}</h3>
                    <div className={classes.list__item}>
                        <a href={'https://docs.google.com/document/d/1HqK6qRWyZkGdOLTOYTynTFJ9tesvqIuQjhyF6nn16bM/edit'}
                            target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_privacy_policy')
                            }}>
                            {strings('footer.privacyPolicy')}
                        </a>
                    </div>
                    <div className={classes.list__item}>
                        <a href={'https://docs.google.com/document/d/1xvDZuqeAliCoX-_FUvjq_MmOIu64oWNz0623dcxEL_8/edit'}
                            target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_term_of_use')
                            }}>
                            {strings('footer.termOfUse')}
                        </a>
                    </div>
                    <div className={classes.list__item}>
                        <a href={'https://docs.google.com/document/d/1DjWF4obwXVqNUtnR5op5ZQPL-lqThfcwu5M9u8z742w/edit'}
                            target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_legal_status')
                            }}>
                            {strings('footer.legalStatus')}
                        </a>
                    </div>
                    <div className={classes.list__item}>
                        <a href={'https://drive.google.com/drive/folders/1Tn7kjtcRUvToVFZ_6OnFpGWbIfjWV6K9?usp=sharing'}
                            target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_press_kit')
                            }}>
                            {strings('footer.pressKit')}
                        </a>
                    </div>
                </div>
                <div className={classes.logo} id={classes.logo}>
                    <div className={classes.logo__item}>
                        <a href={'https://github.com/trustee-wallet/trusteeWallet'} target="_blank"
                            rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_github')
                            }}>
                            <div className={classes.circle}>
                                <img src={github} alt={'github'} width={20} />
                            </div>
                        </a>
                        <a href={'https://bitcointalk.org/index.php?topic=5153571.msg51442318#msg51442318'}
                            target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_bitcoin')
                            }}>
                            <div className={classes.circle}>
                                <img src={bitcoin} alt={'bitcoin'} width={20} />
                            </div>
                        </a>
                        <a href={'http://t.me/trustee_wallet'} target="_blank" rel={'noopener noreferrer'}
                            onClick={() => {
                                analytics().logEvent('click_telegram')
                            }}>
                            <div className={classes.circle}>
                                <img src={telegram} alt={'telegram'} width={20} />
                            </div>
                        </a>
                        <a href={'https://www.youtube.com/c/TrusteeWallet/featured'} target="_blank"
                            rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_youtube')
                            }}>
                            <div className={classes.circle}>
                                <img src={youtube} alt={'youtube'} width={20} />
                            </div>
                        </a>
                        <a href={'https://www.facebook.com/Trustee.Wallet/'} target="_blank"
                            rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_facebook')
                            }}>
                            <div className={classes.circle}>
                                <img src={facebook} alt={'facebook'} width={20} />
                            </div>
                        </a>
                        <a href={'https://www.instagram.com/trustee_wallet/'} target="_blank"
                            rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_instagram')
                            }}>
                            <div className={classes.circle}>
                                <img src={instagram} alt={'instagram'} width={20} />
                            </div>
                        </a>
                        <a href={'https://twitter.com/Trustee_Wallet'} target="_blank"
                            rel={'noopener noreferrer'} onClick={() => {
                                analytics().logEvent('click_twitter')
                            }}>
                            <div className={classes.circle}>
                                <img src={twitter} alt={'twitter'} width={20} />
                            </div>
                        </a>
                        <a href={'https://vk.com/trustee_wallet'} target="_blank" rel={'noopener noreferrer'}
                            onClick={() => {
                                analytics().logEvent('click_vk')
                            }}>
                            <div className={classes.circle}>
                                <img src={vk} alt={'vk'} width={20} />
                            </div>
                        </a>
                    </div>
                </div>
                <div className={classes.list} id={classes.company}>
                    <a href={'https://blocksoftlab.com/'} target={'_blank'} rel={'noopener noreferrer'} onClick={() => {
                        analytics().logEvent('click_blocksoftlab')
                    }}>
                        <h3 className={classes.list__item__header}>Blocksoftlab Inc</h3>
                    </a>
                    <div className={classes.right__reserved}>
                        © {strings('footer.rightsReserved')}
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default withTranslation()(Footer)